import cn from 'classnames';

import Message from '@/design_system/Message';
import Stack from '@/design_system/Stack';
import InlineText from '@/design_system/Typography/InlineText';
import IconInfo from '@/icons/Info.svg';

export const Item = ({
  label,
  value,
  error,
  children,
}: {
  label: string;
  value?: React.ReactNode;
  error?: React.ReactNode;
  children?: React.ReactNode;
}) => {
  return (
    <Stack>
      <Stack
        row
        gap="4px"
        alignItems="center"
        className={cn('text-secondary', {
          'text-danger': !!error,
        })}
      >
        {!!error && <IconInfo style={{ fontSize: '1rem' }} />}
        <InlineText size="200">{label}</InlineText>
      </Stack>
      {!children && (
        <InlineText weight="medium" aria-label={label}>
          {value || '-'}
        </InlineText>
      )}
      {children}
      {!!error && error !== true && (
        <Message type="error" showMessageIcon={false}>
          {error}
        </Message>
      )}
    </Stack>
  );
};
